// function to act as a class
function DatePickerCellEditor() { }

// gets called once before the renderer is used
DatePickerCellEditor.prototype.init = function (params) {

    this.cellStartedEdit = params.cellStartedEdit

    // create the cell
    this.datePicker = document.createElement('input');
    this.datePicker.type = "date";
    this.datePicker.classList.add('ag-input');
    this.datePicker.classList.add('form-control');
    this.datePicker.style.height = '100%';
    this.datePicker.max = "9999-12-31"; // Add max attribute to constrain date entry to 4-digit year.   

    var date = params.value;

    if (date && date != '') {

        // Store the time so we can preserve the same time in and out, this way a date doesn't look edited
        // just because the time got wiped but the day is the same
        this.time = {
            hours: date.getHours(),
            minutes: date.getMinutes(),
            seconds: date.getSeconds()
        };

        // We want to make sure we show the date in the user's local timezone, otherwise the wrong day could appear
        // if it adjusts over a midnight due to UTC
        var adjusted = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes() - date.getTimezoneOffset(),
            date.getSeconds());

        this.datePicker.valueAsDate = adjusted;
    }
};

// gets called once when grid ready to insert the element
DatePickerCellEditor.prototype.getGui = function () {
    return this.datePicker;
};

// focus and select can be done after the gui is attached
DatePickerCellEditor.prototype.afterGuiAttached = function () {
    if (this.cellStartedEdit) {
        this.datePicker.focus();
        this.datePicker.select();
    }
};

//
// Tabbing into the cell
//
DatePickerCellEditor.prototype.focusIn = function () {
    this.datePicker.focus();
};

// returns the new value after editing
DatePickerCellEditor.prototype.getValue = function () {
    if (this.datePicker.value == '') {
        return null;
    }

    var date = new Date(this.datePicker.value + 'T00:00:00');

    // Restore the specific time as it was when the date came in.  The HTML input 'date' doesn't use
    // or preserve time on its own.
    if (this.time) {
        date.setHours(this.time.hours);
        date.setMinutes(this.time.minutes);
        date.setSeconds(this.time.seconds);
    }

    return date;
};